export default class MotiveTranslation {

    id: number;
    name: string;
    locale: string;
    motive_id: number;
}
